import React from 'react';
import ReactDOM from 'react-dom/client';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'
import { loadApiConfig } from './utils/apiConfig';

// Utility to set favicon dynamically
function setFavicon(iconUrl) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = iconUrl;
}
// Utility to set title dynamically
function setTitle(title) {
  if (title) {
    document.title = title;
  }
}
loadApiConfig().then((config) => {
  if (config?.FaviconPath) {
    setFavicon(config.FaviconPath); // dynamically set favicon
  }
  if (config?.Name) {
    setTitle(config.Name); // dynamically set title
  }
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
